import React from 'react';
import { Box } from '@mui/system';
import { Typography } from '@mui/material';
import { MemoReadOnlyJsonEditor } from '../../../../components';
import { jobDetailsAccordionStyle } from './job-manager-details-helper';
import { red } from '@uiw/codemirror-theme-red';

interface JobManagerAccordionErrorProps {
    error: string;
    displayJSON: boolean;
}
const JobManagerAccordionError = ({
    error,
    displayJSON,
}: JobManagerAccordionErrorProps): React.JSX.Element => {
    return (
        <Box sx={displayJSON ? jobDetailsAccordionStyle.jsonContainer : null}>
            <Box sx={jobDetailsAccordionStyle.errorContainer}>
                <Typography sx={jobDetailsAccordionStyle.errorLabel}>
                    Error Log
                </Typography>
            </Box>
            {displayJSON ? (
                <Box sx={jobDetailsAccordionStyle.jsonErrorMessageContainer}>
                    <MemoReadOnlyJsonEditor
                        wrapperContainerStyles={
                            jobDetailsAccordionStyle.wrapperContainer
                        }
                        theme={red}
                        maxHeight={'400px'}
                        jsonData={error}
                    />
                </Box>
            ) : (
                <Box sx={jobDetailsAccordionStyle.errorMessageContainer}>
                    <code>{error}</code>
                </Box>
            )}
        </Box>
    );
};

export default JobManagerAccordionError;
